export const env = {
    name: 'HomeFry',
    email: 'support@homefry.app',
    phone: '(+1)6193179360',
    address: '1041 Market Street',
    city: 'San Diego',
    state: 'CA',
    country: 'United States',
    postal_code: '92101'
};

export const entity = {
    dpo: {
      name: 'Felix O',
      email: 'user-data@homefry.app',
      address: '1041 Market Street',
      city: 'San Diego',
      state: 'CA',
      country: 'United States',
      postal_code: '92101'
    },
    ca: {
      name: 'Felix O',
      email: 'support@homefry.app',
      address: '1041 Market Street',
      city: 'San Diego',
      state: 'CA',
      country: 'United States',
      postal_code: '92101'
    }
}